import { Component, ViewChild, ElementRef, HostListener } from '@angular/core';
import { AngularFirestore } from 'angularfire2/firestore';
import { AngularFireStorage } from 'angularfire2/storage';

import { Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  title = 'app';
  projecten: Observable<any[]>;
  logo: Observable<string | null>;
  afbeeldingen: any ={};
  projectenJSON: Array<any> =[];
  modalInfo: any = null;
  numberImage: number = 0;
  plaats: string = "plaats";

  @ViewChild('mainNav') mainNav: ElementRef;
  @ViewChild('masterhead') masterhead: ElementRef;

  shrink: boolean;

  constructor(db: AngularFirestore, private storage:AngularFireStorage){
	this.projecten = db.collection('projecten').valueChanges();
    this.projecten.subscribe(data =>{
    	this.handleProjecten(data);
    });

    const ref = storage.ref("/logo.png");
    this.logo=ref.getDownloadURL();


    console.log(this.logo);
  }

  setModal(project) {
  	this.numberImage = 0;
  	this.modalInfo = project;
  	this.modalInfo.arrayAfbeeldingen = [project.afbeeldingen.hoofdFoto];
  	if(project.afbeeldingen.extraFotos){
	  	for(var a of project.afbeeldingen.extraFotos){
	  		console.log(this.modalInfo.arrayAfbeeldingen, a);
	  		this.modalInfo.arrayAfbeeldingen.push(a);
	  	}
	  	console.log(this.modalInfo.arrayAfbeeldingen);
	}

  }

  nextImage(num: number){
  	if(this.numberImage+num >= this.modalInfo.arrayAfbeeldingen.length){
  		this.numberImage = 0;
  	}
  	else if(this.numberImage+num <0){
  		this.numberImage = this.modalInfo.arrayAfbeeldingen.length - 1;
  	}
  	else{
  		this.numberImage += num;
  	}
  }

  handleProjecten(data){
  	console.log("data:",data);
  	this.afbeeldingen={};
  	for(var a of data){
  		console.log("0:",a);
  		var b = this.projectenJSON.push({
  			korteTekst: a.korteTekst,
  			locatie: a.locatie,
  			naam: a.naam,
  			datum: a.datum,
        showContact: a.showContact,
        klaar: a.klaar,
        plaats: a.plaats,
  			afbeeldingen:{
  			hoofdFoto:this.storage.ref(a.afbeeldingen.hoofdFoto).getDownloadURL(),
  			extraFotos:[]
  		}
  		});
  		console.log("1:", b);
  		if(a.afbeeldingen.extraFotos[0].length>0){
	  		for(var i in a.afbeeldingen.extraFotos){
	  			console.log("2:", i, this.projectenJSON, b);
		  		this.projectenJSON[b-1].afbeeldingen.extraFotos[i] = this.storage.ref(a.afbeeldingen.extraFotos[i]).getDownloadURL();
		  	}
		}
  	}
  	console.log(this.projecten);
  }

  scrollSmouth($element,$element2){
  	$element.scrollIntoView({behavior: "smooth", block: "start"});
    $element2.setAttribute('class','collapse navbar-collapse');

  }
  @HostListener("window:scroll", [])
  onWindowScroll() {
  	let rect = this.mainNav.nativeElement.getBoundingClientRect();
    let oddTop = rect.top + window.pageYOffset - document.documentElement.clientTop;
    let height = this.masterhead.nativeElement.offsetHeight;

  	if(oddTop > height-this.mainNav.nativeElement.offsetHeight){
  		this.shrink = true;
  	}
  	else{
  		this.shrink = false;
  	}

  }
}
